import { createFileRoute } from "@tanstack/react-router";
import { SecretsList } from "../../features/storage/secrets-list";

export const Route = createFileRoute("/_authed/$org/$project/secrets/")({
  validateSearch: (s: Record<string, unknown>): { q?: string } => (typeof s.q === "string" && s.q ? { q: s.q } : {}),
  component: SecretsPage,
});

function SecretsPage() {
  const { org, project } = Route.useParams();
  return <SecretsList scope={{ org, project }} search={Route.useSearch()} />;
}
